// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-components/build/generate-icons

import { dotSolidDotStrokeMeasurement16X16 } from '@ni/nimble-tokens/dist/icons/js';
import { IconSvg, registerIconSvg } from '../../icon-svg';

declare global {
    interface HTMLElementTagNameMap {
        'nimble-icon-dot-solid-dot-stroke-measurement': IconDotSolidDotStrokeMeasurement;
    }
}

/**
 * The icon component for the 'dotSolidDotStrokeMeasurement' icon
 */
export class IconDotSolidDotStrokeMeasurement extends IconSvg {
    public constructor() {
        super(dotSolidDotStrokeMeasurement16X16);
    }
}

registerIconSvg('icon-dot-solid-dot-stroke-measurement', IconDotSolidDotStrokeMeasurement);
export const iconDotSolidDotStrokeMeasurementTag = 'nimble-icon-dot-solid-dot-stroke-measurement';
